

<!-- 搜尋區域 -->
<div class="search-container">
  <div class="search-filters">
    <div class="search-filter">
      <label for="keyword-filter">{{ 'form.approval.form_name' | translate }}</label>
      <input
        type="text"
        id="keyword-filter"
        [(ngModel)]="searchKeyword"
        class="form-input"
        [placeholder]="'form.list.search_placeholder' | translate"
        (input)="searchForms()">
    </div>


    <div class="search-filter">
      <label for="user-filter">{{ 'form.approval.creator' | translate }}</label>
      <select
        id="user-filter"
        [(ngModel)]="searchUser"
        class="form-select"
        (change)="searchForms()">
        <option value="">{{ 'form.approval.all_users' | translate }}</option>
        <option *ngFor="let user of availableUsers" [value]="user">
          {{ user }}
        </option>
      </select>
    </div>

    <div class="search-actions">
      <button class="clear-button" (click)="clearSearch()" [title]="'form.approval.clear_filter' | translate">
        <i class="fas fa-eraser"></i> {{ 'form.approval.clear_filter' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- 載入指示器 -->
<div *ngIf="loading" class="loading-container">
  <div class="loading-spinner">
    <i class="fas fa-spinner fa-spin"></i>
    <p>{{ 'form.approval.loading' | translate }}</p>
  </div>
</div>

<!-- 錯誤訊息 -->
<div *ngIf="error && !loading" class="error-container">
  <div class="error-message">
    <i class="fas fa-exclamation-triangle"></i>
    <p>{{ error }}</p>
    <button class="retry-btn" (click)="loadApprovalForms()">
      <i class="fas fa-retry"></i> {{ 'form.approval.retry' | translate }}
    </button>
  </div>
</div>

<!-- 表單列表 -->
<div *ngIf="!loading && !error" class="form-list-container">
  <!-- 統計資訊 -->
  <div class="stats-info">
    <p>
      <i class="fas fa-info-circle"></i>
      {{ 'form.approval.stats_info' | translate: {count: filteredForms.length} }}
      <span *ngIf="filteredForms.length !== forms.length">
        {{ 'form.approval.stats_total' | translate: {total: forms.length} }}
      </span>
    </p>
  </div>

  <!-- 表格 -->
  <div class="table-container">
    <table class="approval-forms-table">
      <thead>
        <tr>
           <th>{{ 'form.list.actions' | translate }}</th>
          <th>{{ 'form.approval.form_name' | translate }}</th>
          <th>{{ 'form.approval.creator' | translate }}</th>
          <th>{{ 'form.approval.approval_flow' | translate }}</th>
          <th>{{ 'form.list.created_time' | translate }}</th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let form of filteredForms; trackBy: trackByFormId" class="form-row">

           <!-- 操作按鈕 -->
          <td class="actions">
            <div class="action-buttons">
              <button
                class="action-btn view-btn"
                (click)="viewForm(form)"
                [title]="'form.approval.view_form_details' | translate">
                <i class="fas fa-eye"></i>
                <span>{{ 'form.approval.view_form' | translate }}</span>
              </button>

              <!-- <button
                class="action-btn delete-btn"
                (click)="deleteForm(form)"
                [title]="'common.delete' | translate">
                <i class="fas fa-trash"></i>
                <span>{{ 'common.delete' | translate }}</span>
              </button>  -->
            </div>
          </td>

          <!-- 表單名稱 -->
          <td class="form-name">
            <div class="name-content">
              <i class="fas fa-file-alt"></i>
              <span class="name-text">{{ form.componentname }}</span>
            </div>
          </td>


          <!-- 建立者 -->
          <td class="user-info">
            <span *ngIf="form.username" class="user-tag">
              <i class="fas fa-user"></i>
              {{ form.username }}
            </span>
            <span *ngIf="!form.username" class="no-data">-</span>
          </td>

          <!-- 簽核流程 -->
          <td class="approval-flow">
            <app-approval-flow-display
              [steps]="convertToApprovalFlowSteps(form)"
              [compact]="true"
              [showLabels]="false"
              [enableStepClick]="true"
              [currentUserId]="currentUserId"
              [formId]="form.formid || form.id"
              [formName]="form.componentname"
              [approvalFlow]="getApprovalSteps(form)"
              (approvalComplete)="onApprovalComplete($event)">
            </app-approval-flow-display>
          </td>

          <!-- 建立時間 -->
          <td class="date-info">
            {{ formatDate(form['_ts']) }}
          </td>


        </tr>
      </tbody>
    </table>

    <!-- 無資料提示 -->
    <div *ngIf="filteredForms.length === 0" class="no-data-container">
      <div class="no-data-message">
        <i class="fas fa-inbox"></i>
        <h4>{{ 'form.approval.no_matching_forms' | translate }}</h4>
        <p *ngIf="searchKeyword || searchAssistant || searchUser">
          {{ 'form.approval.adjust_search' | translate }}
        </p>
        <p *ngIf="!searchKeyword && !searchAssistant && !searchUser">
          {{ 'form.approval.no_approval_forms' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- 表單查看彈出視窗 -->
<div *ngIf="showViewForm" class="form-view-modal-overlay" (click)="closeViewForm()">
  <div class="form-view-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <i class="fas fa-eye"></i>
        {{ 'form.approval.view_form_details' | translate }} - {{ viewFormName }}
      </h3>
      <button class="close-button" (click)="closeViewForm()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div *ngIf="viewFormConfig.length === 0" class="loading-message">
        <i class="fas fa-spinner fa-spin"></i>
        {{ 'common.loading' | translate }}
      </div>

      <div *ngIf="viewFormConfig.length > 0">
        <app-form-display
          [formName]="viewFormName"
          [config]="viewFormConfig"
          [formData]="viewFormData">
        </app-form-display>
      </div>
    </div>
  </div>
</div>
